import { defineService } from '@wix/services-definitions';
export const ProvideComponentServiceDefinition = defineService('core:provide-component');
